
itsoftApp.createModule("rellax", function () {
    var module = this;

    var initRellax = function () {
        var elements = document.querySelectorAll('.rellax');
        var el;
        var img;
        var offset;

        if (elements) {
            itsoftApp.loadScript("/assets/scripts/rellax/rellax.js", function () {
                for (let index = 0; index < elements.length; index++) {
                    el = elements[index];
    
                    new Rellax(el, {
                        speed: el.hasAttribute('data-speed') ? el.getAttribute('data-speed') : -5,
                        center: true,
                        vertical: true,
                        horizontal: false
                    });
                };

                function setRotate(img) {
                    offset = window.scrollY / 10;
                    img.style.transform = `rotate(${offset.toFixed(0)}deg)`;
                };

                window.addEventListener('scroll', function() {
                    for (let index = 0; index < elements.length; index++) {
                        img = elements[index].querySelector('img');
                        setRotate(img);
                    };
                })
            });
        }
    };

    initRellax();

    module.callback = initRellax;
});